<template>
    <div class="fixed-scroller">
        <div class="v-alert download">
            <header><p>Download</p><div class="x" @click="$emit('exit')"></div></header>
            <p>{{ item.fileName }}</p>
            <a target="_self" :href="item.blob" :download="item.fileName"><p>download</p></a>
        </div>
    </div>
</template>

<script>

export default {
    props: ['item'],
    mounted () {
        console.log('download item',this.item);
    }
}

</script>

<style lang="scss">
.v-alert.download {
    > p {
        text-align: center;
        margin: 10px 0px 0px 10px
    }
    > a {
        text-align: center;
        margin: 10px;
        float: left;
        width: 100%;

    }
}
</style>